var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80794 11.0195L6.34346 8.06215C5.90924 7.54109 6.27976 6.75 6.95803 6.75L11.042 6.75C11.7202 6.75 12.0908 7.54109 11.6565 8.06215L9.19206 11.0195C9.09211 11.1395 8.90789 11.1395 8.80794 11.0195Z",
    fill: "#E3E8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDown);
export default __webpack_public_path__ + "static/media/calendar_down.15376e4b9eaa0da1aeae46ad9a9f8ac7.svg";
export { ForwardRef as ReactComponent };